import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';

import { SearchPagination } from '@uncinc/react-searchkit';

import { Icon } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';
import { PAGINATION_VIEWPORT } from '../../../config/constants';

export interface SearchAllContentPaginationProps {
  className?: string;
}

const SearchAllContentPagination: React.FC<SearchAllContentPaginationProps> = (props) => {
  const { className } = props;

  const { t } = useTranslation();

  const classNames = c('SearchAllContent__Pagination', className);

  return (
    <div className={classNames}>
      <SearchPagination
        // @ts-expect-error - prop is not typed in RKS.
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
        pageRangeDisplayedPerViewPort={PAGINATION_VIEWPORT}
        previousLabel={(
          <>
            <Icon name="keyboard_arrow_left" flair="filled" />
            <span>{t('searchkit.pagination.prev_label')}</span>
          </>
        )}
        nextLabel={(
          <>
            <span>{t('searchkit.pagination.next_label')}</span>
            <Icon name="keyboard_arrow_right" flair="filled" />
          </>
        )}
      />
    </div>
  );
};

export default SearchAllContentPagination;
